



/* beautify preserve:start */
// prettier-ignore
window.lazySizesConfig=window.lazySizesConfig||{},window.lazySizesConfig.init=!1,function(e,t){var n=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",n,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?n():e.addEventListener("lazyunveilread",n,!0)}(window,function(e,t,n){"use strict";function a(e,n){if(!o[e]){var a=t.createElement(n?"link":"script"),i=t.getElementsByTagName("script")[0];n?(a.rel="stylesheet",a.href=e):a.src=e,o[e]=!0,o[a.src||a.href]=!0,i.parentNode.insertBefore(a,i)}}var i,r,o={};t.addEventListener&&(r=/\(|\)|\s|'/,i=function(e,n){var a=t.createElement("img");a.onload=function(){a.onload=null,a.onerror=null,a=null,n()},a.onerror=a.onload,a.src=e,a&&a.complete&&a.onload&&a.onload()},addEventListener("lazybeforeunveil",function(e){var t,o,s;e.detail.instance==n&&(e.defaultPrevented||("none"==e.target.preload&&(e.target.preload="auto"),(t=e.target.getAttribute("data-link"))&&a(t,!0),(t=e.target.getAttribute("data-script"))&&a(t),(t=e.target.getAttribute("data-require"))&&(n.cfg.requireJs?n.cfg.requireJs([t]):a(t)),(o=e.target.getAttribute("data-bg"))&&(e.detail.firesLoad=!0,i(o,function(){e.target.style.backgroundImage="url("+(r.test(o)?JSON.stringify(o):o)+")",e.detail.firesLoad=!1,n.fire(e.target,"_lazyloaded",{},!0,!0)})),(s=e.target.getAttribute("data-poster"))&&(e.detail.firesLoad=!0,i(s,function(){e.target.poster=s,e.detail.firesLoad=!1,n.fire(e.target,"_lazyloaded",{},!0,!0)}))))},!1))}),function(e){var t=function(e,t,n){"use strict";var a,i;if(function(){var t,n={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:0,throttleDelay:125};for(t in i=e.lazySizesConfig||e.lazysizesConfig||{},n)t in i||(i[t]=n[t])}(),!t||!t.getElementsByClassName)return{init:function(){},cfg:i,noSupport:!0};var r=t.documentElement,o=e.HTMLPictureElement,s="addEventListener",l="getAttribute",d=e[s].bind(e),c=e.setTimeout,u=e.requestAnimationFrame||c,f=e.requestIdleCallback,g=/^picture$/i,z=["load","error","lazyincluded","_lazyloaded"],y={},m=Array.prototype.forEach,v=function(e,t){return y[t]||(y[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")),y[t].test(e[l]("class")||"")&&y[t]},h=function(e,t){v(e,t)||e.setAttribute("class",(e[l]("class")||"").trim()+" "+t)},p=function(e,t){var n;(n=v(e,t))&&e.setAttribute("class",(e[l]("class")||"").replace(n," "))},C=function(e,t,n){var a=n?s:"removeEventListener";n&&C(e,t),z.forEach(function(n){e[a](n,t)})},b=function(e,n,i,r,o){var s=t.createEvent("Event");return i||(i={}),i.instance=a,s.initEvent(n,!r,!o),s.detail=i,e.dispatchEvent(s),s},E=function(t,n){var a;!o&&(a=e.picturefill||i.pf)?(n&&n.src&&!t[l]("srcset")&&t.setAttribute("srcset",n.src),a({reevaluate:!0,elements:[t]})):n&&n.src&&(t.src=n.src)},A=function(e,t){return(getComputedStyle(e,null)||{})[t]},w=function(e,t,n){for(n=n||e.offsetWidth;n<i.minSize&&t&&!e._lazysizesWidth;)n=t.offsetWidth,t=t.parentNode;return n},_=function(){var e,n,a=[],i=[],r=a,o=function(){var t=r;for(r=a.length?i:a,e=!0,n=!1;t.length;)t.shift()();e=!1},s=function(a,i){e&&!i?a.apply(this,arguments):(r.push(a),n||(n=!0,(t.hidden?c:u)(o)))};return s._lsFlush=o,s}(),N=function(e,t){return t?function(){_(e)}:function(){var t=this,n=arguments;_(function(){e.apply(t,n)})}},L=function(e){var t,a=0,r=i.throttleDelay,o=i.ricTimeout,s=function(){t=!1,a=n.now(),e()},l=f&&o>49?function(){f(s,{timeout:o}),o!==i.ricTimeout&&(o=i.ricTimeout)}:N(function(){c(s)},!0);return function(e){var i;(e=!0===e)&&(o=33),t||(t=!0,(i=r-(n.now()-a))<0&&(i=0),e||i<9?l():c(l,i))}},S=function(e){var t,a,i=function(){t=null,e()},r=function(){var e=n.now()-a;e<99?c(r,99-e):(f||i)(i)};return function(){a=n.now(),t||(t=c(r,99))}},M=function(){var o,f,z,y,w,M,B,W,T,k,F,R,q=/^img$/i,D=/^iframe$/i,O="onscroll"in e&&!/(gle|ing)bot/.test(navigator.userAgent),P=0,H=0,$=-1,I=function(e){H--,(!e||H<0||!e.target)&&(H=0)},J=function(e){return null==R&&(R="hidden"==A(t.body,"visibility")),R||!("hidden"==A(e.parentNode,"visibility")&&"hidden"==A(e,"visibility"))},j=function(e,n){var a,i=e,o=J(e);for(W-=n,F+=n,T-=n,k+=n;o&&(i=i.offsetParent)&&i!=t.body&&i!=r;)(o=(A(i,"opacity")||1)>0)&&"visible"!=A(i,"overflow")&&(a=i.getBoundingClientRect(),o=k>a.left&&T<a.right&&F>a.top-1&&W<a.bottom+1);return o},U=function(){var e,n,s,d,c,u,g,z,m,v,h,p,C=a.elements;if((y=i.loadMode)&&H<8&&(e=C.length)){for(n=0,$++;n<e;n++)if(C[n]&&!C[n]._lazyRace)if(!O||a.prematureUnveil&&a.prematureUnveil(C[n]))Z(C[n]);else if((z=C[n][l]("data-expand"))&&(u=1*z)||(u=P),v||(v=!i.expand||i.expand<1?r.clientHeight>500&&r.clientWidth>500?500:370:i.expand,a._defEx=v,h=v*i.expFactor,p=i.hFac,R=null,P<h&&H<1&&$>2&&y>2&&!t.hidden?(P=h,$=0):P=y>1&&$>1&&H<6?v:0),m!==u&&(M=innerWidth+u*p,B=innerHeight+u,g=-1*u,m=u),s=C[n].getBoundingClientRect(),(F=s.bottom)>=g&&(W=s.top)<=B&&(k=s.right)>=g*p&&(T=s.left)<=M&&(F||k||T||W)&&(i.loadHidden||J(C[n]))&&(f&&H<3&&!z&&(y<3||$<4)||j(C[n],u))){if(Z(C[n]),c=!0,H>9)break}else!c&&f&&!d&&H<4&&$<4&&y>2&&(o[0]||i.preloadAfterLoad)&&(o[0]||!z&&(F||k||T||W||"auto"!=C[n][l](i.sizesAttr)))&&(d=o[0]||C[n]);d&&!c&&Z(d)}},G=L(U),K=function(e){var t=e.target;t._lazyCache?delete t._lazyCache:(I(e),h(t,i.loadedClass),p(t,i.loadingClass),C(t,V),b(t,"lazyloaded"))},Q=N(K),V=function(e){Q({target:e.target})},X=function(e){var t,n=e[l](i.srcsetAttr);(t=i.customMedia[e[l]("data-media")||e[l]("media")])&&e.setAttribute("media",t),n&&e.setAttribute("srcset",n)},Y=N(function(e,t,n,a,r){var o,s,d,u,f,y;(f=b(e,"lazybeforeunveil",t)).defaultPrevented||(a&&(n?h(e,i.autosizesClass):e.setAttribute("sizes",a)),s=e[l](i.srcsetAttr),o=e[l](i.srcAttr),r&&(u=(d=e.parentNode)&&g.test(d.nodeName||"")),y=t.firesLoad||"src"in e&&(s||o||u),f={target:e},h(e,i.loadingClass),y&&(clearTimeout(z),z=c(I,2500),C(e,V,!0)),u&&m.call(d.getElementsByTagName("source"),X),s?e.setAttribute("srcset",s):o&&!u&&(D.test(e.nodeName)?function(e,t){try{e.contentWindow.location.replace(t)}catch(n){e.src=t}}(e,o):e.src=o),r&&(s||u)&&E(e,{src:o})),e._lazyRace&&delete e._lazyRace,p(e,i.lazyClass),_(function(){var t=e.complete&&e.naturalWidth>1;y&&!t||(t&&h(e,"ls-is-cached"),K(f),e._lazyCache=!0,c(function(){"_lazyCache"in e&&delete e._lazyCache},9)),"lazy"==e.loading&&H--},!0)}),Z=function(e){if(!e._lazyRace){var t,n=q.test(e.nodeName),a=n&&(e[l](i.sizesAttr)||e[l]("sizes")),r="auto"==a;(!r&&f||!n||!e[l]("src")&&!e.srcset||e.complete||v(e,i.errorClass)||!v(e,i.lazyClass))&&(t=b(e,"lazyunveilread").detail,r&&x.updateElem(e,!0,e.offsetWidth),e._lazyRace=!0,H++,Y(e,t,r,a,n))}},ee=S(function(){i.loadMode=3,G()}),te=function(){3==i.loadMode&&(i.loadMode=2),ee()},ne=function(){f||(n.now()-w<999?c(ne,999):(f=!0,i.loadMode=3,G(),d("scroll",te,!0)))};return{_:function(){w=n.now(),a.elements=t.getElementsByClassName(i.lazyClass),o=t.getElementsByClassName(i.lazyClass+" "+i.preloadClass),d("scroll",G,!0),d("resize",G,!0),d("pageshow",function(e){if(e.persisted){var n=t.querySelectorAll("."+i.loadingClass);n.length&&n.forEach&&u(function(){n.forEach(function(e){e.complete&&Z(e)})})}}),e.MutationObserver?new MutationObserver(G).observe(r,{childList:!0,subtree:!0,attributes:!0}):(r[s]("DOMNodeInserted",G,!0),r[s]("DOMAttrModified",G,!0),setInterval(G,999)),d("hashchange",G,!0),["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){t[s](e,G,!0)}),/d$|^c/.test(t.readyState)?ne():(d("load",ne),t[s]("DOMContentLoaded",G),c(ne,2e4)),a.elements.length?(U(),_._lsFlush()):G()},checkElems:G,unveil:Z,_aLSL:te}}(),x=function(){var e,n=N(function(e,t,n,a){var i,r,o;if(e._lazysizesWidth=a,a+="px",e.setAttribute("sizes",a),g.test(t.nodeName||""))for(r=0,o=(i=t.getElementsByTagName("source")).length;r<o;r++)i[r].setAttribute("sizes",a);n.detail.dataAttr||E(e,n.detail)}),a=function(e,t,a){var i,r=e.parentNode;r&&(a=w(e,r,a),(i=b(e,"lazybeforesizes",{width:a,dataAttr:!!t})).defaultPrevented||(a=i.detail.width)&&a!==e._lazysizesWidth&&n(e,r,i,a))},r=S(function(){var t,n=e.length;if(n)for(t=0;t<n;t++)a(e[t])});return{_:function(){e=t.getElementsByClassName(i.autosizesClass),d("resize",r)},checkElems:r,updateElem:a}}(),B=function(){!B.i&&t.getElementsByClassName&&(B.i=!0,x._(),M._())};return c(function(){i.init&&B()}),a={cfg:i,autoSizer:x,loader:M,init:B,uP:E,aC:h,rC:p,hC:v,fire:b,gW:w,rAF:_}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});
/* beautify preserve:end */

document.addEventListener('lazybeforeunveil', function(e){
  // on data-bg for bg urls
  var bg = e.target.getAttribute('data-bg');
  if(bg){
    e.target.style.backgroundImage = 'url(' + bg + ')';
  }
  // Video Load
  var vsrc = e.target.getAttribute('data-video-src');
  if(vsrc){
    $(e.target).find('source').attr('src', vsrc);
    e.target.load();
  }
});

lazySizesConfig.expFactor = $('body').hasClass('page-lookbook') ? 3 : 1.5;
lazySizes.init();


$('.cart-link').click(function(e) {
  e.preventDefault();
  $("#mini-cart").addClass('open');
  $("#splash").addClass("open");
});


function textareaCharacterLimit(e) {
  let total = 140;
  let $target = e.target ? $(e.target) : $(e);
  let count = $target.val().length;
  let charLeftTarget = $target.siblings('.character-limit').find('.characters-left');
  charLeftTarget.html(total - count);
}


$(document).ready(function () {
 
  $('body').on('click tap', '.klaviyo-form button.CloseButton__StyledSvgInput-sc-1mksxwr-0', function() {
    // do something
    console.log('clicked klaviyo exit');

    $(this).parents().find('.klaviyo-form').parent().remove();
    
  });

  objectFitImages();
  $('select.nice-select').niceSelect();

  checkRemoveLoadingScreenConditions();

  addCurrencyClasses();

  $('textarea[maxlength="140"]').on('input change', textareaCharacterLimit)
  $('textarea[maxlength="140"]').each(function() {
    textareaCharacterLimit(this);
  });

  $(".searchIcon, .searchIconDrk").click(function () {
    $("#searchPop").toggleClass("open");
    $("#bc-sf-search-box-0").focus();
    if(window.pageYOffset < 50){
      $("#shopify-section-header").addClass("fixed");
    }
    setTimeout(() => {
      $("#searchPop.open form input[type=text]").trigger('focus');
      $("#searchPop.open form input[type=text]").trigger('click');
    }, 200);
  });


  /* Bound to the icon itself, not to the bars inside it.

     The three bars are position:absolute and 4px tall, and once the header goes .fixed on scroll the
     plain span.menuHandle collapses from 32x32 to 2px as well ( app.css.liquid, "#shopify-section-
     header.fixed span.menuHandle" ). That left almost the whole icon dead: measured on the live
     page, only 4 of 21 points down its centre had a handler under them once scrolled, against 11 at
     the top of the page. Taps landing anywhere else hit the li, which had nothing bound to it, so
     the menu simply did not open.

     The li is 42x50 and contains every bar, so binding here makes the whole icon live. .menuHandle
     and .menuHandleDrk are deliberately NOT in the selector any more: they are children of this li,
     so they would fire the handler a second time as the event bubbled and toggle the menu straight
     back shut. The bars are set pointer-events:none in sections/header.liquid to match. */
  $(".custom_mobile_menu_icon, .closeMe").click(function () {
    $("#mobNavigation").toggleClass("on");
    $('body').toggleClass('fixed');
  });
  /* was: $(".menuHandle, .menuHandleDrk, .closeMe").click( ... ) */

  // The currency lazy selector can't be directly added due to nice-select. so we add it progrematically on the wrapper
  let needsLazy = $(".div-nice-select-needs-lazy").find("div.nice-select");
  let lazyList = needsLazy.find('ul.list')
  lazyList.hide();
  lazyList.addClass('lazyload');

  //Multi Currency Selector 2019
  $('.shopify-currency-form select').on('change', async function () {
    var selectedCurrency = $(this).val();
    var currentPath = window.location.pathname;
    var isOnEnUs = currentPath.startsWith('/en-us');
    var $form = $(this).parents('form');

    if (selectedCurrency === 'USD' && !isOnEnUs) {
      // Switch to /en-us/ subfolder for USD market
      var returnPath = '/en-us' + currentPath + window.location.search;
      if (!$form.find('input[name="return_to"]').length) {
        $form.append('<input type="hidden" name="return_to" value="' + returnPath + '">');
      } else {
        $form.find('input[name="return_to"]').val(returnPath);
      }
      $form.attr('action', '/en-us/cart/update');
      $form.submit();
      return;
    } else if (selectedCurrency !== 'USD' && isOnEnUs) {
      // Switch back to root for non-USD currencies
      var returnPath = (currentPath.replace(/^\/en-us/, '') || '/') + window.location.search;
      if (!$form.find('input[name="return_to"]').length) {
        $form.append('<input type="hidden" name="return_to" value="' + returnPath + '">');
      } else {
        $form.find('input[name="return_to"]').val(returnPath);
      }
      $form.attr('action', '/cart/update');
      $form.submit();
      return;
    }

    $form.submit();

    addCurrencyClasses();
  });

  $("#splash").click(function () {
    $("#mini-cart").removeClass("open");
    $("#splash").removeClass("open");
  });
  $('.hc-close').click(function () {
    $("#mini-cart").removeClass("open");
    $("#splash").removeClass("open");
  });


  // handle product max qty input
  document.querySelectorAll('.quantity[title="Product quantity"]')?.forEach(input => {
    input.addEventListener('input', function () {
      const maxQty = parseInt(this.getAttribute('max'));
      const curQty = parseInt(this.value);
      if (maxQty && maxQty < curQty) this.value = maxQty;
    });
  });

  function valueChangeInput(input, amount) {
    var curVal = parseInt(input.val());
    const packSize = parseInt(input.data('pack'));
    const prdPage = input.hasClass('ctm_qnty_breack');
    console.log(prdPage, "prdPageprdPage")
    const selectedPack = prdPage ? document.querySelector('.styled_option_values_inner_cstm_var input[type="radio"]:checked') : null;

    if(packSize){
      if(amount > 0){
        var added = curVal + packSize;
      }else{
        var added = curVal - packSize;
      }  
    }
    else if(selectedPack){
      const custAmount =  parseInt(selectedPack.value);
      if(amount > 0){
        var added = curVal + custAmount;
      }else{
        var added = curVal - custAmount;
      }      
    }else{
      var added = curVal + amount;
    }

    var newVal = added < 0 ? curVal : added;
    console.log('newVal',newVal)

    let maxQty = parseInt(input.attr('max'));
    const stepSize = packSize || (selectedPack ? parseInt(selectedPack.value) : 0);

    if (maxQty) {
      // When using packs, cap maxQty to the nearest lower multiple of the pack size
      const effectiveMax = stepSize > 1 ? Math.floor(maxQty / stepSize) * stepSize : maxQty;

      if (newVal <= effectiveMax) {
         if(newVal > 0){ input.val(newVal);}
         else if(!prdPage){input.val(newVal);}
        if (input.parents('.quantity-selection').attr('qty_msg')) input.parents('.quantity-selection').removeAttr('qty_msg');
      }
      else if(stepSize > 1){
        input.val(effectiveMax > 0 ? effectiveMax : curVal);
        input.parents('.quantity-selection').attr('qty_msg', `maximum quantity is ${effectiveMax}`)
      }
      else{
        input.val(maxQty);
        input.parents('.quantity-selection').attr('qty_msg', `maximum quantity is ${maxQty}`)
      }
    }
    else{
      input.val(newVal); // Update value using jQuery's val() method
    }
    


    const event = new Event('change', { bubbles: true, cancelable: true });
    input.get(0).dispatchEvent(event); // Dispatch event on the DOM element

    if (input.get(0).value == 0 && input.parents('.item-details').get(0)) input.parents('.item-details').get(0).classList.add('removeable_item');

    if ($('body').hasClass('cart')) {
      let key = input.closest('.item-details').data('key');
      let pageCartDetails = $(".cart-details[data-key='" + key + "']").find('.quantity-input');
      pageCartDetails.val(newVal);
      if (newVal <= 0) {
        let row = pageCartDetails.closest('.cart-row');
        if (row.length > 0) {
          row.remove();
        }
      }
    }
  }


  $(document).on('click', '.plus-quantity', function (e) {
    e.preventDefault();
    var $input = $(this).siblings('.quantity-input');
    valueChangeInput($input, 1);
    return false;
  });

  $(document).on('click', '.minus-quantity', function (e) {
    e.preventDefault();
    var $input = $(this).siblings('.quantity-input');
    valueChangeInput($input, -1);
    return false;
  });

  $(document).on('click', '.qtyplus_', function (e) {
    e.preventDefault();
    var $input = $(this).siblings('.product-form__input');
    valueChangeInput($input, 1);
    return false;
  });

  $(document).on('click', '.qtyminus_', function (e) {
    e.preventDefault();
    var $input = $(this).siblings('.product-form__input');
    valueChangeInput($input, -1);
    return false;
  });


  $(document).on('click', '.hc-remove', function (e) {
    e.preventDefault();
    var $input = $(this).parent().find('.quantity-input');
    if ($input.length <= 0) { 
      $input = $(this).parent().siblings().find('.quantity-input');
      let key = $input.closest('.item-details').data('key');
      // console.log('key', key);
      let $inputSideCart = $("#mini-cart .item-details[data-key='"+key+"']").find('.quantity-input')
      $inputSideCart.val('0').trigger('change');
    } 
    // console.log('$input',$input);
    if ($('body').hasClass('cart')) {
      // console.log('REMOVING ITEM');
      let key = $input.closest('.item-details').data('key');
      let pageCartDetails = $(".cart-details[data-key='" + key + "']");
      pageCartDetails.closest('.cart-row').remove();
    }
    $input.parents('.item-details').addClass('removeable_item')
    // $input.val('0').trigger('change');
    $input.val('0');
    const event = new Event('change', { bubbles: true, cancelable: true });
    $input.get(0).dispatchEvent(event);
    return false;
  });


  $(document).on('click', '.up', function (e) {
    e.preventDefault();
    var $input = $(this).siblings('.quantity');
    valueChangeInput($input, 1);    
    return false;
  });

  $(document).on('click', '.downer', function (e) {
    e.preventDefault();
    var $input = $(this).siblings('.quantity');
    valueChangeInput($input, -1);
    return false;
  });


  $('a[href*=\\#]').click(function () {
    let headerHeight = $('#header').height();
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname) {
        var $target = $(this.hash);
        let hashTarget = '[name=' + this.hash.slice(1) + ']';
        if (hashTarget === '[name=]') return;
        $target = $target.length && $target ||
        $('[name=' + this.hash.slice(1) + ']');
        if ($target.length) {
          var targetOffset = $target.offset().top;
          $('html,body')
            .animate({
              scrollTop: targetOffset - headerHeight
            }, 500);
          return false;
        }
    }
  });

  $("#dropMe").click(function () {
    $("#cartExtras").toggleClass("open");
    $("#dropMe").toggleClass("close");
  });

  $(window).scroll(function () {

    var scroll = $(window).scrollTop();

    checkScrollBounce(scroll);

    checkScrollNavigation(scroll);

    checkScrollMaxTopFilters(scroll);

    checkCounterScroll('1');

    checkCounterScroll('2');

    checkCounterScroll('3');


  });

  $('#four-sixty-mobile-container').addClass('loaded');
  $('.bc-sf-filter-block-title h3 span').addClass('up');
  $('.bc-sf-filter-block-content ').css('display', 'none');
  $('.product-add input.add').removeAttr('disabled');
  $('.product-add input.add').prop('value', 'add to bag');
  $('.instashop-carousel').removeClass('long-load-fix');
  $('#mobile-product').removeClass('long-load-fix');
  $('#carousel-top-panel .headline').html('<a href="">Legendary Reviews 🍻</a>');
});

$(window).on('load', preloadAllImages);

function bgUrlTrim(backgroundImageUrl) {
  return backgroundImageUrl.replace(/^url\(['"](.+)['"]\)/, '$1');
}

function preloadAllImages() {
  preloadBackgroundImage($("#header").find('li'));
  var filterOptionQuery = ".bc-sf-filter-option-item span:first-child";
  let targetNode = document.getElementById('bc-sf-filter-default-toolbar');
  if (targetNode !== null) {
    
    let config = {
      childList: true, subtree: true
    }
    const callback = function(mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for(let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // console.log('A child node has been added or removed.');
          preloadBackgroundImage($(filterOptionQuery));
          preloadBackgroundImageHover($(filterOptionQuery));
        }
      }
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
    
    preloadBackgroundImage($(filterOptionQuery));
    preloadBackgroundImageHover($(filterOptionQuery));

  }

}

function preloadBackgroundImage(element) {
  element.each(function() {

    let item = $(this);

    let backgroundImage = item.css("background-image");
    if (backgroundImage === 'none') return;
    
    let url = bgUrlTrim(backgroundImage);

    preloadImageUrl(url);
  });
}

function insertBeforeLastOccurrence(strToSearch, strToFind, strToInsert) {
  var n = strToSearch.lastIndexOf(strToFind);
  if (n < 0) return strToSearch;
  return strToSearch.substring(0,n) + strToInsert + strToSearch.substring(n);    
}

function preloadBackgroundImageHover(element) {
  element.each(function() {

    let item = $(this);

    let backgroundImage = item.css("background-image");
    
    if (backgroundImage === 'none') return;

    let url = bgUrlTrim(backgroundImage);
    url = url.substring(0, url.indexOf('?'));

    //let hoverBgUrl = insertBeforeLastOccurrence(url, ".png", "-hover");
    
    //preloadImageUrl(hoverBgUrl);

  });
}

function preloadImageUrl(url) {
  let preloadImageUrl = new Image();
  preloadImageUrl.src = url;
}

function checkScrollBounce(scroll) {
  if (scroll <= 50) {
    $(".bounce.onlight").removeClass("hideme");
  } else if (scroll > 50) {
    $(".bounce.onlight").addClass("hideme");
  }
}

function checkScrollNavigation(scroll) {
  if (scroll >= 45) {
    $("#shopify-section-header").addClass("fixed");
    $("body").addClass("scroll");
    $("#mobNavigation").addClass('padBot');
  } else if (scroll < 45) {
    $("#shopify-section-header").removeClass("fixed");
    $("body").removeClass("scroll");
    $("#mobNavigation").removeClass('padBot');
  }
}
function showLoadingScreen() {
  let cannotShowLoadingScreen = $('body').hasClass('product, product-gift-box, product-facecovers');
  if (cannotShowLoadingScreen) return;
  $('#loading').fadeIn(300);
  setTimeout(function() {
    $('#loading img').fadeIn(200);
  }, 100)
}

function getHeroSelector(width) {
  if (width >= 1001) {
    console.log('desktop hero selector');
    return $('#homepage1 .desktop_hero');
  } else if (width >= 501 && width <= 1000) {
    console.log('tablet hero selector');
    return $('#homepage1 .tablet_hero');
  } else if (width <= 500) {
    console.log('mobile hero selector');
    return $('#homepage1 .mobile_hero')
  }

  console.log('desktop hero selector');
  return $('#homepage1 .desktop_hero');

}

function checkRemoveLoadingScreenConditions() {
  console.log('checking loading screen conditions');
  // if body has class index.
  // grab the background url thats in their and force it into a js image and wait for load and then show the page.
  // when time goes beyond 1 second just show the page
  // else if the page is not index just show the page

  let now = +new Date;

  function removeLoadingScreen() {

    let doneTime = +new Date - now;
    // console.log('time took to load image:', doneTime);

    clearTimeout(removeTimer);
    $('#loading').fadeOut(300);
    $('#loading img').fadeOut(200);

  }

  // Set timer for 5 second, if the image hasn't loaded then, just show the page.

  // var removeTimer = setTimeout(removeLoadingScreen, 5000);
  var removeTimer = setTimeout(removeLoadingScreen, 200);

  if ($('body').hasClass('index')) {
    // console.log('body has class index');

    // Grab the url thats assigned to the homepage banner through css

    let selector = getHeroSelector(window.innerWidth);

    let backgoundImageUrl = selector.attr('data-srcset') || selector.attr('srcset') || selector.attr('src');
    if (backgoundImageUrl) backgoundImageUrl = backgoundImageUrl.split(',')[0].trim().split(' ')[0];

    // console.log('backgoundImageUrl',backgoundImageUrl);
    let preloadImage = new Image();

    preloadImage.addEventListener("load", function () {

      // console.log('hero image loaded succesfully!');
      removeLoadingScreen();

    });

    preloadImage.src = backgoundImageUrl;

  } else {

    removeLoadingScreen();

  }
}

function checkScrollMaxTopFilters(scroll) {
  let headerHeight = $('#header').height();
  let collectionFilters = $('.bc-sf-filter-wrapper-page');
  if (collectionFilters.length) {
    // console.log('Filters!');

    let offset = collectionFilters.offset();

    let productWrapper = $('#bc-sf-filter-wrapper');

    let topStart = scroll + headerHeight;
    let topEnd = productWrapper.offset().top + productWrapper.height() - (headerHeight * 2);

    if (topStart >= offset.top && scroll < topEnd) {
      collectionFilters.addClass('collection-filters-scroll');
    } else {
      collectionFilters.removeClass('collection-filters-scroll');
    }

  }
}

$(function () {


  $("#fundamentals-handle").click(function () {
    $(".httat").removeClass("showall");
    $(".fundamentals").css('display', 'block');
    $(".timeless").css('display', 'none');
    $(".james-bond").css('display', 'none');
    $(".flamboyant").css('display', 'none');

    $("#fundamentals-handle").addClass("alive");
    $("#timeless-handle").removeClass("alive");
    $("#flamboyant-handle").removeClass("alive");
    $("#james-bond-handle").removeClass("alive");
  });
  $("#timeless-handle").click(function () {
    $(".httat").removeClass("showall");
    $(".fundamentals").css('display', 'none');
    $(".timeless").css('display', 'block');
    $(".james-bond").css('display', 'none');
    $(".flamboyant").css('display', 'none');

    $("#fundamentals-handle").removeClass("alive");
    $("#timeless-handle").addClass("alive");
    $("#flamboyant-handle").removeClass("alive");
    $("#james-bond-handle").removeClass("alive");
  });
  $("#flamboyant-handle").click(function () {
    $(".httat").removeClass("showall");
    $(".fundamentals").css('display', 'none');
    $(".timeless").css('display', 'none');
    $(".james-bond").css('display', 'none');
    $(".flamboyant").css('display', 'block');

    $("#fundamentals-handle").removeClass("alive");
    $("#timeless-handle").removeClass("alive");
    $("#flamboyant-handle").addClass("alive");
    $("#james-bond-handle").removeClass("alive");
  });
  $("#james-bond-handle").click(function () {
    $(".httat").removeClass("showall");
    $(".fundamentals").css('display', 'none');
    $(".timeless").css('display', 'none');
    $(".james-bond").css('display', 'block');
    $(".flamboyant").css('display', 'none');

    $("#fundamentals-handle").removeClass("alive");
    $("#timeless-handle").removeClass("alive");
    $("#flamboyant-handle").removeClass("alive");
    $("#james-bond-handle").addClass("alive");
  });
  $(".more-button").click(function () {
    $(".httat").addClass("showall");

    $(".fundamentals").css('display', 'block');
    $(".timeless").css('display', 'block');
    $(".james-bond").css('display', 'block');
    $(".flamboyant").css('display', 'block');

    $("#fundamentals-handle").removeClass("alive");
    $("#timeless-handle").removeClass("alive");
    $("#flamboyant-handle").removeClass("alive");
    $("#james-bond-handle").removeClass("alive");
  });
  $("#instashop-close").click(function () {
    $("#faded-background").removeClass("open");
    $("#body").removeClass("fixed");
    $("#instashopping").removeClass("open");
  });

  $("#close-cookies, .accept-cookies").click(function () {
    $("#cookie-policy").removeClass("open");
  });

  $("#add-gift-note").click(function () {
    $("#gift-note-wrapper").toggleClass("open");
  });
  $('#dynamic_select').on('change', function () {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });
});

function autoPlayVideo(vcode) {
  "use strict";
  $(".video_holder").toggleClass('open');
  $(".video_wrapper").toggleClass('open');
  $(".video_wrapper").html('<iframe src="https://www.youtube.com/embed/' + vcode + '?autoplay=1&controls=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
}

function addCurrencyClasses() {
  let $current = $('.current');
  let currentIsocode = $current.eq(0).html();
  let newIsocode = $current.eq(1).html();
  $current.parent().removeClass(currentIsocode);
  $current.parent().addClass(newIsocode);
}

$.fn.isOnScreen = function () {

  if (this.length === 0) return;

  var win = $(window);

  var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();

  var bounds = $(this).offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};

function checkCounterScroll(which) {
  if ($('#counter-trigger-' + which).isOnScreen()) {
    $('.count-me-' + which).each(function () {
      var $this = $(this);
      jQuery({
        Counter: 0
      }).animate({
        Counter: $this.attr("data")
      }, {
        duration: 3000,
        easing: 'swing',
        step: function () {
          $this.text(Math.ceil(this.Counter));
        }
      });
      $('.count').removeClass('count-me-' + which);
    });
  }
}


/* beautify preserve:start */
// Yotpo widget
// prettier-ignore
document.addEventListener('startasyncloading', function() {!function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src="//staticw2.yotpo.com/F0wtkH1PAhmlnUjDN37PW0YnopiARHZTIiapUMa6/widget.js";var e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(t,e)}();});
// IE11 img polyfill
// prettier-ignore
var objectFitImages=function(){"use strict";function t(t,e,i){var r=function(t,e){return"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='"+t+"' height='"+(i||0)+"'%3E%3C/svg%3E"}(e||1);f.call(t,"src")!==r&&d.call(t,"src",r)}function e(t,i){t.naturalWidth?i(t):setTimeout(e,100,t,i)}function i(i){var n=function(t){for(var e,i=getComputedStyle(t).fontFamily,r={};null!==(e=s.exec(i));)r[e[1]]=e[2];return r}(i),o=i[c];if(n["object-fit"]=n["object-fit"]||"fill",!o.img){if("fill"===n["object-fit"])return;if(!o.skipTest&&a&&!n["object-position"])return}if(!o.img){o.img=new Image(i.width,i.height),o.img.srcset=f.call(i,"data-ofi-srcset")||i.srcset,o.img.src=f.call(i,"data-ofi-src")||i.src,d.call(i,"data-ofi-src",i.src),i.srcset&&d.call(i,"data-ofi-srcset",i.srcset),t(i,i.naturalWidth||i.width,i.naturalHeight||i.height),i.srcset&&(i.srcset="");try{r(i)}catch(i){window.console&&console.warn("https://bit.ly/ofi-old-browser")}}(function(t){if(t.srcset&&!g&&window.picturefill){var e=window.picturefill._;t[e.ns]&&t[e.ns].evaled||e.fillImg(t,{reselect:!0}),t[e.ns].curSrc||(t[e.ns].supported=!1,e.fillImg(t,{reselect:!0})),t.currentSrc=t[e.ns].curSrc||t.src}})(o.img),i.style.backgroundImage='url("'+(o.img.currentSrc||o.img.src).replace(/"/g,'\\"')+'")',i.style.backgroundPosition=n["object-position"]||"center",i.style.backgroundRepeat="no-repeat",i.style.backgroundOrigin="content-box",/scale-down/.test(n["object-fit"])?e(o.img,function(){o.img.naturalWidth>i.width||o.img.naturalHeight>i.height?i.style.backgroundSize="contain":i.style.backgroundSize="auto"}):i.style.backgroundSize=n["object-fit"].replace("none","auto").replace("fill","100% 100%"),e(o.img,function(e){t(i,e.naturalWidth,e.naturalHeight)})}function r(t){var e={get:function(e){return t[c].img[e||"src"]},set:function(e,r){return t[c].img[r||"src"]=e,d.call(t,"data-ofi-"+r,e),i(t),e}};Object.defineProperty(t,"src",e),Object.defineProperty(t,"currentSrc",{get:function(){return e.get("currentSrc")}}),Object.defineProperty(t,"srcset",{get:function(){return e.get("srcset")},set:function(t){return e.set(t,"srcset")}})}function n(t,e){var r=!m&&!t;if(e=e||{},t=t||"img",l&&!e.skipTest||!u)return!1;"img"===t?t=document.getElementsByTagName("img"):"string"==typeof t?t=document.querySelectorAll(t):"length"in t||(t=[t]);for(var s=0;s<t.length;s++)t[s][c]=t[s][c]||{skipTest:e.skipTest},i(t[s]);r&&(document.body.addEventListener("load",function(t){"IMG"===t.target.tagName&&n(t.target,{skipTest:e.skipTest})},!0),m=!0,t="img"),e.watchMQ&&window.addEventListener("resize",n.bind(null,t,{skipTest:e.skipTest}))}var c="bfred-it:object-fit-images",s=/(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g,o="undefined"==typeof Image?{style:{"object-position":1}}:new Image,a="object-fit"in o.style,l="object-position"in o.style,u="background-size"in o.style,g="string"==typeof o.currentSrc,f=o.getAttribute,d=o.setAttribute,m=!1;return n.supportsObjectFit=a,n.supportsObjectPosition=l,function(){function t(t,e){return t[c]&&t[c].img&&("src"===e||"srcset"===e)?t[c].img:t}l||(HTMLImageElement.prototype.getAttribute=function(e){return f.call(t(this,e),e)},HTMLImageElement.prototype.setAttribute=function(e,i){return d.call(t(this,e),e,String(i))})}(),n}(); document.addEventListener("StartAsyncLoading",function(){document.querySelectorAll(".lazyload_image").forEach(t=>{void 0!==t.dataset.src&&(t.src=t.dataset.src),void 0!==t.dataset.srcset&&(t.srcset=t.dataset.srcset),t.classList.remove("lazyload_image")})});
/* beautify preserve:end */
